var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 500",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    id: "blobSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.32671356201172, 9.550216674804688)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#561BE3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "7000ms",
    repeatCount: "indefinite",
    values: "M456,335.5Q421,421,335.5,451.5Q250,482,165,451Q80,420,60.5,335Q41,250,66,170.5Q91,91,170.5,78Q250,65,319,88.5Q388,112,439.5,181Q491,250,456,335.5Z;       M423.5,323Q396,396,323,432Q250,468,186,423Q122,378,96,314Q70,250,72,162Q74,74,162,44.5Q250,15,314.5,68Q379,121,415,185.5Q451,250,423.5,323Z;              M422.5,327.5Q405,405,327.5,438.5Q250,472,179,432Q108,392,84,321Q60,250,78.5,173.5Q97,97,173.5,51.5Q250,6,333.5,44.5Q417,83,428.5,166.5Q440,250,422.5,327.5Z;       M434.5,315Q380,380,315,439.5Q250,499,170.5,454Q91,409,66.5,329.5Q42,250,70.5,174.5Q99,99,174.5,82Q250,65,319,88.5Q388,112,438.5,181Q489,250,434.5,315Z;       M438.5,321.5Q393,393,321.5,425.5Q250,458,171.5,432.5Q93,407,55,328.5Q17,250,58,174.5Q99,99,174.5,83Q250,67,325,83.5Q400,100,442,175Q484,250,438.5,321.5Z;        M456,335.5Q421,421,335.5,451.5Q250,482,165,451Q80,420,60.5,335Q41,250,66,170.5Q91,91,170.5,78Q250,65,319,88.5Q388,112,439.5,181Q491,250,456,335.5Z;       "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.3d2c0687d0859c15beafe655f03b663a.svg";
export { ForwardRef as ReactComponent };